import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { registerLocaleData } from '@angular/common';
import localeSv from '@angular/common/locales/sv';
import localeEn from '@angular/common/locales/en';
import { AuthGuard, LoginWrapperComponent, ProductListComponent, SavedCartListComponent, AdminGuard } from 'gung-standard';
import { CultHomeComponent } from './components/cult-home/cult-home.component';
import { CultProductDetailsComponent } from './components/cult-product-details/cult-product-details.component';
import { JeevesOrderDetailsComponent } from 'gung-standard-jeeves';
import { CultLoginComponent } from './components/cult-login/cult-login.component';
import { CultCheckoutWrapperComponent } from './components/checkout/cult-checkout-wrapper/cult-checkout-wrapper.component';
import { CultOrderConfirmationComponent } from './components/cult-order-confirmation/cult-order-confirmation.component';
import { CultCustomerDetailsComponent } from './components/cult-customer-details/cult-customer-details.component';
import { CultFlowDetailsComponent } from './components/flow-details/cult-flow-details/cult-flow-details.component';
import { CultOrderDetailsComponent } from './components/cult-order-details/cult-order-details.component';
import { CultUserDetailsComponent } from './components/cult-user-details/cult-user-details.component';
import { CultActivityInternalWrapperComponent } from './components/cult-activity-internal-wrapper/cult-activity-internal-wrapper.component';

@Component({
  selector: 'cult-root',
  template: `<cult-wrapper></cult-wrapper>`,
  styles: []
})
export class CultAppComponent {
  title = 'Cult design';

  constructor(private router: Router, translate: TranslateService) {
    const lang = localStorage.getItem('selectedLanguage');
    translate.use(lang || 'se');
    registerLocaleData(localeSv);
    registerLocaleData(localeEn);
    this.setupRoutes();

    translate.onLangChange.subscribe((event: LangChangeEvent) => {
      localStorage.setItem('selectedLanguage', event.lang);
    });
  }

  private setupRoutes() {
    const routerConfig = this.router.config;
    this.router.resetConfig([
      {
        path: '',
        component: CultHomeComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'forgot-password',
        component: LoginWrapperComponent,
        data: {
          login: 'FashionLogin'
        }
      },
      {
        path: 'login',
        component: LoginWrapperComponent,
        data: {
          login: 'FashionLogin'
        }
      },
      {
        path: 'product/:productId',
        component: CultProductDetailsComponent,
        canActivate: [AuthGuard]
      },
      /* {
        path: 'product/:productId',
        canActivate: [AuthGuard],
        component: ProductDetailWrapperComponent
      }, */
      {
        path: 'products/:assortmentId',
        component: ProductListComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'orders/:orderId',
        component: CultOrderDetailsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'carts',
        component: SavedCartListComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'checkout',
        canActivate: [AuthGuard],
        component: CultCheckoutWrapperComponent
      },
      {
        path: 'order-confirmation/:contextId',
        canActivate: [AuthGuard],
        component: CultOrderConfirmationComponent
      },
      {
        path: 'customers/:customerId',
        component: CultCustomerDetailsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'admin/gung-flow-details/:flowId',
        component: CultFlowDetailsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'admin/users-details/:username',
        component: CultUserDetailsComponent,
        canActivate: [AuthGuard, AdminGuard]
      },
      {
        path: 'activity-internal/:type',
        component: CultActivityInternalWrapperComponent,
        canActivate: [AuthGuard]
      },
      ...routerConfig
    ]);
  }
}
